import template	from "./dialog-config-email.html";
import css		from "./dialog-config-email.css";

import Dialog	from "dialog";
import later	from "later";

/* this is for the design file */
import Richbox	from "richbox";

class EmailConfigDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-email", EmailConfigDialog);
  }
  connectedCallback() {
    super.connectedCallback();
    
  	this.init();  
  }
  constructor() {
    super();
    
    this.show();
  }
  async init() {
    var settings = await server.rcall("RM_getEmailSettings");
            
    this.textboxUsername.value = settings.username?settings.username:"";
    this.textboxFrom.value = settings.from?settings.from:"";
    this.textboxTo.value = settings.to?settings.to:"";
    this.passwordPassword.value = settings.password?settings.password:"";
    this.textboxHost.value = settings.host?settings.host:"";
    this.textboxPort.value = settings.port?settings.port:"";
    this.textboxSchedule.value = settings.schedule?settings.schedule:"";
    this.richboxMessage.value = settings.message?settings.message:"";        
    this.checkboxEnableProgressReport.checked = settings.enableProgressReport?true:false;
  }
  async buttonClose_click() {
    this.close();
  }
  async buttonSave_click() {
    var settings = {
      username: this.textboxUsername.value,
      from: this.textboxFrom.value,
      to: this.textboxTo.value,
      password: this.passwordPassword.value,
      host: this.textboxHost.value,
      port: this.textboxPort.value,
      schedule: this.textboxSchedule.value,
      message: this.richboxMessage.value,
      enableProgressReport: this.checkboxEnableProgressReport.checked
    };
    
    await server.rcall("RM_setEmailSettings", settings);    
  }
  async buttonTest_click() {
    await server.rcall("RM_emailTest");
  }
}

EmailConfigDialog.constructor();

export default EmailConfigDialog;